module.exports = __webpack_public_path__ + "static/bg01-1b4fca104ac305ad740218f0d291bc01.png";